import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.img`
  width: 100%;
  height: 251px;
  object-fit: cover;
  object-position: 50% 68%;

  &.image-enter,
  &.image-appear {
    opacity: 0;
  }

  &.image-enter-active,
  &.image-appear-active {
    opacity: 1;
    transition: opacity 500ms;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    object-position: initial;
  }
`;
